import React from 'react'
import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Common/Icon'
import { Flex } from '@mobi/component-library/Common/Flex'
import { colors, spacing } from '@mobi/component-library/Theme/Common'
import { isKambiSportsSingleSelection } from '@mobi/betslip/helpers/typeGuards'
import type { KambiSportsEventDetails, KambiSportsMultiSelection } from '@mobi/betslip/types'
import { SecondaryInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SecondaryInfo'
import { SelectionInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SelectionInfo'
import { getSelectionNameFromKambiBetOffer } from '@core/Areas/Quickbet/helpers/selectionsKambi'

export const KambiSportsHeaderMulti: React.FC<{
  selection: KambiSportsMultiSelection

  eventDetails: KambiSportsEventDetails
}> = ({ selection, eventDetails }) => {
  return (
    <WrapperStyled>
      <SecondaryInfo marketInfo={`${selection.legs.length} Leg Multi`} />

      <Flex flexDirection='column' gap='1rem'>
        {selection.legs.map(leg => {
          if (isKambiSportsSingleSelection(leg)) {
            const event = eventDetails.events.find(event => event.id === leg.betOffer.eventId)
            return (
              <React.Fragment key={leg.betOffer.id}>
                <Flex flexDirection='column' gap={spacing.smx1}>
                  <SecondaryInfo
                    marketInfo={
                      <>
                        <Icon type='tab' size='1.6rem' />
                        <span>{event?.englishName}</span>
                      </>
                    }
                  />

                  <SelectionInfo
                    leftSlot={
                      <div
                        style={{
                          width: '3rem',
                          height: '3rem',
                          borderRadius: '50%',
                          background: '#47245D',
                          flexShrink: 0,
                        }}
                      />
                    }
                    text={getSelectionNameFromKambiBetOffer(leg.betOffer)}
                    subText={leg.betOffer.criterion.label}
                  />
                </Flex>
                <div className='multi-info__divider' />
              </React.Fragment>
            )
          }

          const event = eventDetails.events.find(event => event.id === leg.betOffers[0].eventId)
          return (
            <React.Fragment key={leg.betOffers.map(offer => offer.id).join('')}>
              <Flex flexDirection='column' gap={spacing.smx1}>
                <SecondaryInfo
                  marketInfo={
                    <>
                      <Icon type='tab' size='1.6rem' />
                      <span>{event?.englishName}</span>
                    </>
                  }
                />

                {leg.betOffers.map(offer => (
                  <SelectionInfo
                    key={offer.id}
                    leftSlot={
                      <div
                        style={{
                          width: '3rem',
                          height: '3rem',
                          borderRadius: '50%',
                          background: '#47245D',
                          flexShrink: 0,
                        }}
                      />
                    }
                    text={getSelectionNameFromKambiBetOffer(offer)}
                    subText={offer.criterion.label}
                  />
                ))}
              </Flex>
              <div className='multi-info__divider' />
            </React.Fragment>
          )
        })}
      </Flex>
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.sm,
  paddingBottom: spacing.smx2,

  '.multi-info__divider': {
    height: '1px',
    width: '100%',
    backgroundColor: colors.studio[600],

    '&:last-of-type': { display: 'none' },
  },
})
